import './Footer.css';

export default function Footer() {
    return (
        <footer>
            <h1>Pizzeria Busca Vida</h1>
            <h2>Viale Della Repubblica, 29 - 57023 Cecina (Li)</h2>
            <h3><a href="tel:+393513478565">+39 351 3478565</a> | <a href="mailto:buscavidapizzeria@gmail.com">buscavidapizzeria@gmail.com</a></h3>
            <h4>P.I. 02072210491 | Informazioni Legali | Privacy Policy e Cookie Policy</h4>
            {/*<p>&copy; 2024 BuscaVida Pizzeria</p>*/}
        </footer>
    );
}